export const actionTypes = {
  GET_PRODUCTS: "GET_PRODUCTS",
  SET_PRODUCTS: "SET_PRODUCTS",

  GET_PRODUCT_BY_ID: "GET_PRODUCT_BY_ID",
  SET_PRODUCT_BY_ID: "SET_PRODUCT_BY_ID",

  SAVE_PRODUCTS: "SAVE_PRODUCTS",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",

  SET_EDIT_PRODUCT_LOADER: "SET_EDIT_PRODUCT_LOADER"
};

export const actions = {
  getProducts: (payload) => ({
    type: actionTypes.GET_PRODUCTS,
    payload: payload,
  }),

  setProducts: (payload) => ({
    type: actionTypes.SET_PRODUCTS,
    payload: payload,
  }),

  getProductById: (payload) => ({
    type: actionTypes.GET_PRODUCT_BY_ID,
    payload: payload,
  }),

  setProductById: (payload) => ({
    type: actionTypes.SET_PRODUCT_BY_ID,
    payload: payload,
  }),

  setEditProductLoader: (payload) => ({
    type: actionTypes.SET_EDIT_PRODUCT_LOADER,
    payload: payload,
  }),

  saveProducts: (payload) => ({
    type: actionTypes.SAVE_PRODUCTS,
    payload: payload,
  }),

  updateProducts: (payload) => ({
    type: actionTypes.UPDATE_PRODUCTS,
    payload: payload,
  }),
};
